import useSWR from 'swr';
import { AdminSettingsService } from '@/services/engine/admin-settings-service';
import type {
    ActivityPulse,
    ActivityPulseWindow,
} from '@/types/admin-settings';

const CACHE_KEY = 'admin-activity-pulse';

export function useActivityPulse(windowDays: ActivityPulseWindow) {
    const { data, isLoading, error } = useSWR<ActivityPulse>(
        [CACHE_KEY, windowDays],
        () => AdminSettingsService.getActivityPulse(windowDays),
        { revalidateOnFocus: false },
    );

    return { pulse: data, isLoading, error };
}
